<template>
  <div class="text-center">
    <input
      type="checkbox"
      aria-label="Select row"
      v-model="object.isRowSelected"
      :disabled="!!object.rmProceduresCount"
    />
  </div>
</template>

<script>
export default {
  name: 'RowSelectionRenderer',
  props: {
    object: {
      type: Object,
    },
  },
}
</script>
